import { useContext, useState } from 'react';
import { MetaConnectionModalContext } from './MetaConnectionModal.constants.ts';
import { tMetaConnectionModalContext } from './MetaConnectionModa.types.ts';
import { tGetMetaPagesData } from '../../../../../providers/IntegrationsProvider/Integrations.types.ts';

export default function useMetaConnectionModal(): tMetaConnectionModalContext {
  const [loading, setLoading] = useState<boolean>(false);
  const [connected, setConnected] = useState<boolean>(false);
  const [step, setStep] = useState<number>(1);
  const [metaPages, setMetaPages] = useState<tGetMetaPagesData[]>([]);

  return {
    loading,
    setLoading,
    connected,
    setConnected,
    step,
    setStep,
    metaPages,
    setMetaPages,
  };
}

export const useMetaConnectionModalContext = () =>
  useContext(MetaConnectionModalContext);
